import { Component, Input } from '@angular/core';
import { IDocumentDto } from '../../../dto/document-listing.dto';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';

@Component({
  selector: 'app-template-name',
  templateUrl: './template-name.component.html',
  styleUrl: './template-name.component.scss'
})
export class TemplateNameComponent {

  @Input() dataItem: IDocumentDto;
  public columnOptions: ITableColumn;
}
